import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  constructor(private http:HttpClient) { }


   getAllPackage(data:any){
    return this.http.post(environment.apiUrl + "packages/get/pagination" , data);
  }

  updatePackage(data:any){
    return this.http.post(environment.apiUrl + "packages/update" , data);
  }

  searchPackage(data:any){
    return this.http.post(environment.apiUrl + "packages/search" , data);
  }
}
